export default __webpack_public_path__ + "static/media/mobile_financial.a44b1e4f.svg";